import { render, staticRenderFns } from "./DropdownCustomList.vue?vue&type=template&id=ffbb1be0&scoped=true&"
import script from "./DropdownCustomList.vue?vue&type=script&lang=js&"
export * from "./DropdownCustomList.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCustomList.vue?vue&type=style&index=0&id=ffbb1be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb1be0",
  null
  
)

export default component.exports